module.exports = __webpack_public_path__ + "img/960.a91c4152.svg";